import MapBlock from '../components/Map/MapBlock.jsx';

function RootPage() {
  return (
    <div>
      <div
        className="map_card"
        style={{ height: 'calc(100vh - 50px)', position: 'relative' }}
      >
        <MapBlock />
      </div>
    </div>
  );
}

export default RootPage;
